module.exports = new __parcel__URL__("make-something-wonderful.59144c13.jpg").toString();